// Leichtgewichtiger HTML-Sanitizer (ohne externe Abhängigkeit).
// Entfernt potenziell gefährliche Tags/Attribute aus Rich-Text-Inhalten
// (z. B. aus dem Quill-Editor), bevor sie via dangerouslySetInnerHTML
// gerendert werden. Schützt vor gespeicherten XSS-Angriffen.

const ALLOWED_TAGS = new Set([
  'a', 'b', 'strong', 'i', 'em', 'u', 's', 'sub', 'sup',
  'p', 'br', 'span', 'div',
  'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'blockquote', 'pre', 'code', 'hr',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'img',
]);

const ALLOWED_ATTR = new Set([
  'href', 'target', 'rel', 'src', 'alt', 'title',
  'class', 'style', 'colspan', 'rowspan', 'width', 'height',
]);

/**
 * Bereinigt einen HTML-String und gibt nur erlaubte Tags/Attribute zurück.
 * Entfernt u. a. <script>, Event-Handler (onclick, ...) und javascript:-URLs.
 */
export function sanitizeHtml(dirty: string | undefined | null): string {
  if (!dirty) return '';

  // DOMParser ist im Browser verfügbar und parst sicher (führt keine Skripte aus).
  const doc = new DOMParser().parseFromString(dirty, 'text/html');

  const clean = (node: Element): void => {
    for (const el of Array.from(node.children)) {
      const tag = el.tagName.toLowerCase();

      if (!ALLOWED_TAGS.has(tag)) {
        el.remove();
        continue;
      }

      for (const attr of Array.from(el.attributes)) {
        const name = attr.name.toLowerCase();
        const value = attr.value;

        const isAllowed = ALLOWED_ATTR.has(name) && !name.startsWith('on');
        const isDangerousUrl =
          (name === 'href' || name === 'src') &&
          /^\s*(javascript|data|vbscript):/i.test(value);

        if (!isAllowed || isDangerousUrl) {
          el.removeAttribute(attr.name);
        }
      }

      // Links, die in neuem Tab geöffnet werden, gegen Tabnabbing absichern
      if (tag === 'a' && el.getAttribute('target') === '_blank') {
        el.setAttribute('rel', 'noopener noreferrer');
      }

      clean(el);
    }
  };

  clean(doc.body);
  return doc.body.innerHTML;
}
